import React from 'react';
import { getTranslatedString } from 'helpers/i18n';
import Form from 'components/ui/Form';

import { Switch } from 'ui-library/components/Switch/Switch';

import { isTemplate } from '../NoticeHelpers';

const AssignManagementContactInput = ({ values, errors, touched, setFieldValue }) => {
  const handleChange = (attach) => {
    setFieldValue('attach_management_contact', attach);
  };

  if (!isTemplate(values)) return null;

  return (
    <Form.Item
      validateStatus={
        touched.attach_management_contact && errors.attach_management_contact ? 'error' : null
      }
      help={touched.attach_management_contact && errors.attach_management_contact}
    >
      <Switch
        label={getTranslatedString('landlordPortal.noticeForm.wouldYouLikeToAttach')}
        checked={!!values.attach_management_contact}
        value={values.attach_management_contact}
        name="attach_management_contact"
        onChange={handleChange}
      />
    </Form.Item>
  );
};

export default AssignManagementContactInput;
